// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs-JnwmP","separator":"separator-P7leC"};